import { FC } from 'react'

import styled from 'styled-components'

import SpotifyIcon from 'src/Assets/Svg/platform-icons/SpotifyLight.svg?react'
import { Avatar } from 'src/Components/Avatar'
import { addSpaceToNumber } from 'src/Helpers/layoutHelpers'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'

const ARTIST_AVATAR_SIZE = 40
const PLATFORM_ICON_SIZE = 24

const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
  flex-basis: calc(50% - 48px);

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    border-radius: 16px;
    flex-basis: unset;
  }
`

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const DesktopIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

const MobileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

const Header = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Description = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

const Artist = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  min-width: 0;
`

const ArtistInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  line-height: 150%;
`

const ArtistName = styled.span`
  font-weight: ${variables.fontWeight600};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const Followers = styled.span`
  font-weight: ${variables.fontWeight400};
`

export interface PreReleaseArtistDetailsProps {
  artistName: string
  followersCount: number
  photoUrl?: string
}

export const PreReleaseArtistDetails: FC<PreReleaseArtistDetailsProps> = ({
  artistName,
  followersCount,
  photoUrl,
}) => (
  <Container>
    <DesktopIconWrapper>
      <SpotifyIcon width={PLATFORM_ICON_SIZE} />
    </DesktopIconWrapper>

    <DescriptionWrapper>
      <HeaderWrapper>
        <MobileIconWrapper>
          <SpotifyIcon width={PLATFORM_ICON_SIZE} />
        </MobileIconWrapper>
        <Header>New Artist Profile</Header>
      </HeaderWrapper>

      <Description>
        Ready to amplify your music&apos;s exposure? Fill in the contact details
        to access a world of promotional opportunities!
      </Description>
    </DescriptionWrapper>

    <Artist>
      <Avatar
        src={photoUrl}
        width={ARTIST_AVATAR_SIZE}
        height={ARTIST_AVATAR_SIZE}
      />
      <ArtistInfo>
        <ArtistName>{artistName}</ArtistName>
        <Followers>{`${addSpaceToNumber(followersCount, ',')} followers`}</Followers>
      </ArtistInfo>
    </Artist>
  </Container>
)
